// Contact information and fallback responses for AI Chat
export class ContactService {
  // Get comprehensive contact information
  static getContactInfo() {
    return {
      email: 'dhrumitpatel.ai@gmail.com',
      linkedin: 'https://linkedin.com/in/dhrumitpatelds',
      github: 'https://github.com/Dhrumit1314',
      huggingface: 'https://huggingface.co/Dhrumit1314',
      portfolio: 'https://dhrumitpatel.com',
      portfolioContact: '#contact',
      location: 'Toronto, ON, Canada'
    };
  }

  // Get formatted contact information for AI responses
  static getFormattedContactInfo() {
    const contact = this.getContactInfo();
    return `
### 📞 Contact Information

**Primary Contact:**
• **Email:** ${contact.email}
• **LinkedIn:** [${contact.linkedin}](${contact.linkedin})
• **Portfolio:** [${contact.portfolio}](${contact.portfolio})
• **Contact Form:** [Fill out contact form](${contact.portfolioContact})

**Professional Profiles:**
• **GitHub:** [${contact.github}](${contact.github})
• **Hugging Face:** [${contact.huggingface}](${contact.huggingface})

**Location:** ${contact.location}
`;
  }

  // Get fallback response when AI can't answer a question
  static getFallbackResponse(question = '') {
    const contact = this.getContactInfo();
    
    return `I don't have specific information about that, but I'd be happy to help you get in touch with Dhrumit directly!

### 📞 Contact Information

**Primary Contact:**
• **Email:** ${contact.email}
• **LinkedIn:** [${contact.linkedin}](${contact.linkedin})
• **Portfolio:** [${contact.portfolio}](${contact.portfolio})
• **Contact Form:** [Fill out contact form](${contact.portfolioContact})

**Professional Profiles:**
• **GitHub:** [${contact.github}](${contact.github})
• **Hugging Face:** [${contact.huggingface}](${contact.huggingface})

**Location:** ${contact.location}

**💡 How to reach Dhrumit:**
• **For professional inquiries:** Email him at ${contact.email}
• **For networking:** Connect on [LinkedIn](${contact.linkedin})
• **For project collaborations:** Check out his [GitHub repositories](${contact.github})
• **For detailed questions:** [Fill out the contact form](${contact.portfolioContact}) on his portfolio website

**🎯 What Dhrumit can help with:**
• AI/ML project collaborations
• Financial crime model validation expertise
• Full-stack development projects
• Machine learning consulting
• Open source contributions
• Professional networking

Feel free to reach out with your specific questions or project ideas!`;
  }

  // Get specific contact recommendation based on question type
  static getContactRecommendation(questionType) {
    const contact = this.getContactInfo();
    
    const recommendations = {
      'job': `For job opportunities, please email Dhrumit at ${contact.email} with your requirements and company details.`,
      'project': `For project collaborations, check out his [GitHub](${contact.github}) and then reach out via email or LinkedIn.`,
      'consulting': `For consulting opportunities, connect on [LinkedIn](${contact.linkedin}) or email ${contact.email}.`,
      'networking': `For networking, connect on [LinkedIn](${contact.linkedin}) or check out his [portfolio](${contact.portfolio}).`,
      'technical': `For technical questions, check his [GitHub repositories](${contact.github}) or [Hugging Face profile](${contact.huggingface}).`,
      'personal': `For personal inquiries, please [fill out the contact form](${contact.portfolioContact}) on his portfolio website.`,
      'default': `Please email Dhrumit at ${contact.email} or [fill out the contact form](${contact.portfolioContact}) on his portfolio website.`
    };

    return recommendations[questionType] || recommendations.default;
  }

  // Get portfolio sections for navigation
  static getPortfolioSections() {
    return {
      about: 'About section with detailed background',
      skills: 'Technical skills and technologies',
      experience: 'Work experience and achievements',
      projects: 'Portfolio projects and GitHub repositories',
      contact: 'Contact form and information'
    };
  }
} 